import { render } from "./viaturaFilter.vue?vue&type=template&id=133305fa&scoped=true"
import script from "./viaturaFilter.vue?vue&type=script&lang=js"
export * from "./viaturaFilter.vue?vue&type=script&lang=js"

import "./viaturaFilter.vue?vue&type=style&index=0&id=133305fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133305fa"]])

export default __exports__